import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    toggleButtonGroupRoot: {
      justifyContent: 'center',
      marginTop: 8,
      marginBottom: 22,
      width: '100%',
    },
    toggleButtonSelected: {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: `${theme.palette.common.white} !important`,
      fontWeight: 500,
    },
    toggleButtonRoot: {
      backgroundColor: theme.palette.text.white,
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      textTransform: 'capitalize',
      fontWeight: 500,
      padding: '6px 11px',
    },
    modalHeader: {
      paddingRight: 22,
    },
  };
});

export default useStyles;
